[
  {
    "key": "caldav",
    "img": "/assets/integrations/cover/caldav.jpg",
    "whiteBackground": true,
    "local": true,
    "cloud": true,
    "deprecated": true,
    "categories": ["services"]
  }
]
